import React, { Fragment, useEffect, useState } from 'react'
import PageTitle from '../../layouts/PageTitle'
import Select from "react-select";
import { useCallback } from "react";
import useRazorpay from "react-razorpay";
import countries from '../../../mock/countries.json';
import { Button } from 'react-bootstrap';
import swal from 'sweetalert';
import { addDonation,  trigerMails, addMagicpotDonation } from '../../../helper/BackendHelper';
import { useHistory } from 'react-router-dom';
import PageLoader from '../../layouts/PageLoader';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';
import SelectCampaignWithEvent from '../../components/Common/SelectCampaignWithEvent';
import PludgeMeal from '../../components/Common/PludgeMeal';
import { notifyError } from '../../../helper/notification';
import { Ippopay } from 'react-ippopay';

const initialData = {}

/*
const paymentMethodSInitial = [
    {
        "value": 1,
        "lable": "Online"
    },
    {
        "value": 2,
        "lable": "UPI"
    },
    {
        "value": 3,
        "lable": "Cheque"
    },
    {
        "value": 4,
        "lable": "Wire Transfer"
    }
]
*/

const MagicpotAddPay = () => {

    // console.log({countries});
    const Razorpay = useRazorpay();
    const [formData, setformData] = useState(initialData);
    const [campaignData, setCampaignData] = useState([]);

    const [isLoading, setIsLoading] = useState(false);   
    const [eventDate, setEventDate] = useState(new Date());
   // const [paymentMethods, setPaymentMethods] = useState(paymentMethodSInitial);    

    // console.log({ isCampaign });
    const [userSelect, setUserSelect] = useState(false);
    const [selectedUser, setSelectedUser] = useState();

    const router = useHistory();

    const onChangeValue = (e) => {
        setformData({ ...formData, [e?.currentTarget?.name]: e?.currentTarget?.value })
    }

   

    const initialLoad = async () => {}


    const formSubmit = async (e) => {
        e.preventDefault();
      
        setIsLoading(true);
      
        const finalData = {
          ...formData,
          event_date: new Date(eventDate).toISOString().split('T')[0],
        };
      
        if (!finalData.event_date) {
          alert('Event date is required');
          setIsLoading(false);
          return;
        }
      
        const res = await addMagicpotDonation(finalData); // ✅ send as plain JSON object
        console.log(res.status)
        if (res?.status === 'success') {
          swal(`Donations added`, ``, "success");
          setIsLoading(false);
          router.push('/magicpot-dashboard');
          trigerMails();
        } else {
           swal(res?.message, ``, "error");
           setIsLoading(false);
         // handleError(res);
        }
      };
      

    const onEventDateSelect = (date) => {
        setEventDate(new Date(date))
        setformData({ ...formData, event_date: moment(date).format("YYYY-MM-DD") })
    }


    const onAmountChange = (e) => {
        // setformData({ ...formData, meals: null, amount: e?.currentTarget?.value })
        setformData({ ...formData, amount: e?.currentTarget?.value })
    }


    //console.log({ event_date });

    return (
        <Fragment>
            

            <PageLoader isLoading={isLoading} >
                {/* <PageTitle activeMenu="Doner" motherMenu="Add New Doner" /> */}
               
               

                <div className="row">
                    <div className="col-xl-12 col-lg-12">
                        <div className="card">
                            <div className="card-header container-fluid" style={{ display: "block" }}>
                                <div class="row">
                                    <div class="col-md-7">
                                        <h4 className="card-title">Payment Details</h4>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <div className="basic-form">
                                    <form onSubmit={formSubmit}>
                                        <fieldset disabled={isLoading}>
                                            <div className="row">
                                                <div className="col-lg-6">
                                                    <div className="col-auto">
                                                        <label className="sr-only">Donation Amount</label>
                                                        <div className="input-group mb-3">
                                                            <div className="input-group-text">₹</div>

                                                            <input
                                                                type="number"
                                                                className="form-control"
                                                                placeholder="Amount"
                                                                name='amount'
                                                                required
                                                                onChange={onAmountChange}
                                                                min="1"
                                                                value={formData?.amount}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-6">
                                                  
                                                    <div className="form-group mb-3">
                                                         <DatePicker className="form-control" selected={eventDate} onSelect={onEventDateSelect} placeholderText="Select Event Date" dateFormat="yyyy-MM-dd" name='event_date'  maxDate={new Date()} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-6">
                                                    <div className="form-group mb-3">
                                                        <textarea name="venue_details" id="venue_details" className="form-control input-default "
                                                            placeholder="Venue details" rows="5"
                                                            onChange={onChangeValue}
                                                            value={formData?.venue_details} >
                                                        </textarea>
                                                    </div>
                                                </div>
                                                <div className="col-lg-6">
                                                    <div className="col-auto">
                                                        <div className="input-group mb-3">
                                                            <textarea name="menu_details" id="menu_details" className="form-control input-default "
                                                                placeholder="Menu details" rows="5"
                                                                onChange={onChangeValue} >
                                                            </textarea>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-lg-6">
                                                    <Button type='submit' variant="primary">{isLoading ? "Adding...." : "Add Payment"}</Button>
                                                </div>
                                            </div>
                                        </fieldset>

                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </PageLoader>

        </Fragment>
    )
}

export default MagicpotAddPay